import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TreeSelect } from '@components';
import { setValoresSelecionados } from '@ducks/indicadoresVariaveisAmbiente';
import styled from 'styled-components';

const TreeSelectComponent = styled(TreeSelect)`
  width: 100% !important;
`;

export default function TreeSet({ treeData }) {
  const dispatch = useDispatch();

  const treeValue = useSelector(({ indicadoresVariaveisAmbiente }) => indicadoresVariaveisAmbiente.get('valoresSelecionados'));

  const onChange = (value) => dispatch(setValoresSelecionados(value));

  const tProps = {
    treeData,
    value: treeValue,
    onChange,
    treeCheckable: true,
    placeholder: 'Selecione os valores',
  };

  return <TreeSelectComponent {...tProps} />;
}
